<template lang="pug">
	.network-show--clock-detail.flex-col.space-medium
		EditableLabelField(:caption="$tCaption('Name')", :value.sync="item.Name", type="text", stylingMode="filled", :editingMode="true")
		.flex-row.space
			EditableLabelField(:caption="$tCaption('Effective date')", :value.sync="item.EffectiveDate", type="date", stylingMode="filled", :editingMode="true")
			EditableLabelField(:caption="$tCaption('Hour')", :value.sync="item.Hour", type="number", stylingMode="filled", :editingMode="true")
		EditableLabelField(:caption="$tCaption('Description')", :value.sync="item.Description", type="area", stylingMode="filled", :editingMode="true")
</template>

<script>
	import EditableLabelField from 'app-core/EditableLabelField.vue';

	export default {
		translationCategory: 'networkShow.ClockDetail',
		name: 'network-show--clock-detail',
		props: ['item'],
		components: {
			EditableLabelField
		},
		data() {
			return {
			};
		},
		mounted() {
			if (__DEBUG__)
				window.networkShowClockDetail = this;
		},
		methods: {
			
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.network-show--clock-detail {
	}
</style>
